import React from "react";
import useAppContext from "./useAppContext";
import {isFreePricingPlanId} from "../consts/freePricingPlans";

const UseCredits = () => {
    const { data: { shop } } = useAppContext();
    const credits = shop.data?.credits;
    const isFreePlan = isFreePricingPlanId(shop.data?.pricingPlan?.id);
    const availableCredits = credits?.availableCredits;
    const isPlanSupportCredits = shop.data?.pricingPlan?.allowExtraCreditPurchase;
    const allowedToPurchaseCredits = shop.data?.pricingPlan?.allowExtraCreditPurchase;

    return {
        credits,
        isPlanSupportCredits,
        isFreePlan,
        allowedToPurchaseCredits,
        availableCredits
    };
}

export default UseCredits;